import {NgModule} from '@angular/core';

import {ContentStatusBadgeComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the content status badge
 */
@NgModule({
  declarations: [ContentStatusBadgeComponent],
  exports: [ContentStatusBadgeComponent],
  imports: [
    IonicModule,
  ],
  providers: [],
})
export class ContentStatusBadgeModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-status-badge/content-status-badge.module.ts